import { render, staticRenderFns } from "./controlFeedback.vue?vue&type=template&id=a161f49a&scoped=true&"
import script from "./controlFeedback.vue?vue&type=script&lang=js&"
export * from "./controlFeedback.vue?vue&type=script&lang=js&"
import style0 from "./controlFeedback.vue?vue&type=style&index=0&id=a161f49a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a161f49a",
  null
  
)

export default component.exports